"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistedQueriesLink = void 0;
exports.sha256 = sha256;
const persisted_queries_1 = require("@apollo/client/link/persisted-queries");
const sha256_browser_1 = require("@aws-crypto/sha256-browser");
async function sha256(...args) {
    const hash = new sha256_browser_1.Sha256();
    // We trim the query string here as well as in the http-link to ensure that the hash is consistent across different environments.
    hash.update(args.map((arg) => (typeof arg === "string" ? arg.trim() : arg)).join(""));
    return Array.from(await hash.digest())
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
}
const persistedQueriesLink = () => {
    return (0, persisted_queries_1.createPersistedQueryLink)({
        sha256,
        useGETForHashedQueries: true,
    });
};
exports.persistedQueriesLink = persistedQueriesLink;
//# sourceMappingURL=persisted-queries-link.js.map